import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { warning } from "../../../../../utils/notifications"
import { EditPajeraModalDialog } from "./EditPajeraModalDialog/EditPajeraModalDialog"
import { defaultRenderer, diferencialDefaultRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"

export const PrecipitacionTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, dataMASTER, setData, simulated, original, saveLoading, same, scenarioBase } = props

    const [state] = useContext(UserContext)

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }


    const handleEditCellContent = (params:any) => {
        let { colId } = params.column
        
        let modo = colId.split("_")
        modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
        if(modo.slice(-1)[0] === 'a') {
            if(simulated.scenario_base && !original.scenario_base) {
                warning("No se puede editar un escenario que ya está simulado.")
            } else if(colId !== 'litros_metro_2_a' && original.scenario_base) {
               warning("No se puede editar el escenario original.")
            } else if(colId === 'nombre_zona' || colId === 'mes') {
                console.log("not allowed")
            } else if(original.scenario_base) {
                warning("No se puede editar el escenario original.")
            } else if(same) {
                warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
            } else {
                setSelectedCell(colId)
                setSelectedRow(params.data)
                setVisible(true)
            }
        } else {
            if(simulated.scenario_comparision && !original.scenario_comparision) {
                warning("No se puede editar un escenario que ya está simulado.")
            } else if(colId !== 'litros_metro_2_b' && original.scenario_comparision) {
                warning("No se puede editar el escenario original.")
            } else if(colId === 'nombre_zona' || colId === 'mes') {
                console.log("not allowed")
            } else if(original.scenario_comparision) {
                warning("No se puede editar el escenario original.")
            } else if(same) {
                warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
            } else {
                setSelectedCell(colId)
                setSelectedRow(params.data)
                setVisible(true)
            }
        }
        
    }

    const handleCellStyleEditable = (params:any) => {
        let original = dataMASTER.precipitation_table.find((ori:any) => `${ori.cod_zona}${ori.mes_id}` === `${params.data.cod_zona}${params.data.mes_id}`)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyle = (params:any) => {
        let original = dataMASTER.precipitation_table.find((ori:any) => `${ori.cod_zona}${ori.mes_id}` === `${params.data.cod_zona}${params.data.mes_id}`)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const monthCellRenderer = (params:any) => {
        if(params.data.mes_id === null) {
            return ''
        }
        return params.value.charAt(0).toUpperCase() + params.value.slice(1)
    }
    

    return (
        <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'97.5%', width: '65%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'97.5%', width: '65%' }}>
                <EditPajeraModalDialog
                    visible={visible}
                    setVisible={setVisible}
                    handleClose={handleClose}
                    selectedCell={selectedCell}
                    setSelectedCell={setSelectedCell}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    mode={mode}
                    setMode={setMode}
                    data={data}
                    dataMASTER={dataMASTER}
                    setData={setData}   
                />
                {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContent : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.precipitation_table}
                    enableCellTextSelection
                    >

                    <AgGridColumn sortable   suppressNavigable={true} flex={1} hide   field={"id_mes"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyle}  suppressNavigable={true} flex={1}  headerClass={"header-resize"}   headerName={"Nombre Zona"} field={"nombre_zona"}></AgGridColumn>

                    <AgGridColumn sortable cellStyle={handleCellStyle}  suppressNavigable={true} flex={1} cellRenderer={monthCellRenderer} headerClass={"header-resize"}   headerName={"Mes"} field={"mes"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyle} sort={'asc'}  headerClass={"header-resize"}   suppressNavigable={true} flex={1} cellRenderer={defaultRenderer}   headerName={"Cod Zona"} field={"cod_zona"} hide></AgGridColumn>

                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Litros/m²" flex={1} >
                        <AgGridColumn cellStyle={handleCellStyleEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc A" field="litros_metro_2_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialDefaultRenderer}  flex={1} suppressNavigable  headerName="Esc B" field="litros_metro_2_b"></AgGridColumn>
                    </AgGridColumn>
    
                </AgGridReact>
            </div>
    )
}